import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


@Injectable()
export class CustomerReportsService {

    public VesselAndProcessId: string;
    public CustomerId: string;

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/customerReports/customer-reports.service.ts